import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LeagueDetailCard from "./LeagueDetailCard";
import { stripHtml } from "./leagueStatus";
import {
  ArrowLeftIcon,
  JoinedConfettiCheckIcon,
  SmallLockIcon,
  TrophyOutlineIcon,
  SmallCheckCircleIcon,
} from "./icons";

const InfoCard = ({ icon, title, titleColor = "#0F172A", children }) => (
  <div className="rounded-2xl border border-[#E5E7EB] bg-[#F2FBF6] p-4 md:p-5">
    <div className="flex items-start gap-3">
      <div className="shrink-0 w-12 h-12 rounded-full bg-white flex items-center justify-center">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="inter font-semibold text-base" style={{ color: titleColor }}>
          {title}
        </h3>
        {children && <div className="mt-1">{children}</div>}
      </div>
    </div>
  </div>
);

const PrivateLeagueJoinedSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const game = location.state?.game;

  if (!game) {
    navigate("/contest", { replace: true });
    return null;
  }

  return (
    <div className="min-h-[calc(100vh-6rem)] pb-12 bg-white md:bg-transparent">
      <div className="max-w-screen-md mx-auto px-4 md:px-8 pt-2">
        <div className="flex items-center justify-between mb-2 md:mt-6">
          <button
            type="button"
            onClick={() => navigate("/contest")}
            aria-label="Go back"
            className="p-2 -ml-2 text-[#0F172A] inline-flex items-center gap-1 text-sm dm-sans hover:text-[#0F4146]"
          >
            <ArrowLeftIcon />
            <span className="hidden md:inline">Back</span>
          </button>
          <div className="w-9" />
        </div>

        <div className="flex flex-col items-center text-center pt-1 md:pt-4">
          <JoinedConfettiCheckIcon className="w-40 h-40 md:w-48 md:h-48" />
          <h1 className="mt-1 inter font-bold text-3xl md:text-4xl text-[#0F172A]">You're in!</h1>
          <p className="mt-2 text-sm md:text-base text-[#66748C] dm-sans">
            <span className="text-[#22A36B] inter font-medium">{game.title}</span> has been added to My Leagues.
          </p>
        </div>

        <div className="mt-5 space-y-4">
          <LeagueDetailCard game={game} />

          <InfoCard icon={<SmallLockIcon className="w-7 h-7" />} title="Private League" titleColor="#22A36B">
            <p className="text-sm text-[#0F172A] dm-sans">
              This is an invite only trading group. Members can post updates, share charts,
              discuss trade ideas, comment, like, and follow the league leaderboard together.
            </p>
            <ul className="mt-2 space-y-1.5 text-sm text-[#0F172A] dm-sans">
              <li className="inline-flex items-center gap-2">
                <SmallCheckCircleIcon /> Join before the league starts
              </li>
              <li className="inline-flex items-center gap-2">
                <SmallCheckCircleIcon /> Portfolios and trade activity visible to league members
              </li>
            </ul>
          </InfoCard>

          {!!game.reward?.trim() && (
            <InfoCard icon={<TrophyOutlineIcon className="w-7 h-7" stroke="#22A36B" />} title="Recognition">
              <p className="text-sm text-[#0F172A] dm-sans">{stripHtml(game.reward)}</p>
            </InfoCard>
          )}

          <button
            type="button"
            onClick={() => navigate(`/contest/${game.vanity_url}`)}
            className="mt-2 w-full rounded-xl bg-[#0F4146] text-white py-3.5 inter font-medium hover:bg-[#0B3A3F] transition-colors"
          >
            View League
          </button>
          <button
            type="button"
            onClick={() => navigate("/contest")}
            className="w-full text-center inter font-medium text-sm text-[#22A36B] py-3"
          >
            Back to League Play
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivateLeagueJoinedSuccess;
